import React, { createContext, useState, useEffect, useContext } from 'react';

const ApiContext = createContext(undefined);

export const ApiProvider = ({ children }) => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [AUTH_TOKEN, setauthToken] = useState(() => localStorage.getItem("access_token"));

  const loginSuccess = (newToken) => {
    localStorage.setItem("access_token", newToken);
    setauthToken(newToken);
  };

  useEffect(() => {
    const EXTERNAL_API_URL = "https://imedia-api.growatiopex.com/playablehub/getAllDataSite";

    const fetchExternalData = async () => {
      try {
        console.log("AUTH_TOKEN", AUTH_TOKEN);

        if (AUTH_TOKEN && AUTH_TOKEN != null) {
          setLoading(true);

          const response = await fetch(EXTERNAL_API_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${AUTH_TOKEN}`
            },
            body: JSON.stringify({ site: "uber" })
          });

          if (!response.ok) {
            console.log("Step");

            // throw new Error(`API Error: ${response.status} ${response.statusText}`);
            const isRefreshed = await generateRefreshToken();
          }
          const result = await response.json();
          setApiData(result.data);
        }

      } catch (err) {
        console.error("Failed to fetch external API:", err);
        setApiError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchExternalData();
  }, [AUTH_TOKEN]);

  const generateRefreshToken = async () => {
    const refreshToken = localStorage.getItem("refresh_token")
    try {
      const response = await fetch("https://imedia-api.growatiopex.com/playablehub/refresh-token", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refreshToken: refreshToken })
      });
      const result = await response.json();
      if (result.success == true) {
        localStorage.setItem("access_token", result.accessToken);
        setauthToken(result.accessToken)
      }
      return true;
    } catch (error) {
      setApiError(error.message);
      return false
    }
  }


  console.log("apiData", apiData);

  return (
    <ApiContext.Provider value={{ apiData, loading, apiError, loginSuccess }}>
      {children}
    </ApiContext.Provider>
  );
};

export const useExternalData = () => {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useExternalData must be used within an ApiProvider');
  }
  return context;
};